import { asyncComponent } from './components/async-component'

export const CCDetailPage = asyncComponent(
  () => import(/* webpackChunkName: "CCDetailPage" */ './components/marketplace/cc-detail-page'),
  'CCDetailPage'
)

export const CCListingPage = asyncComponent(
  () => import(/* webpackChunkName: "CCListingPage" */ './components/marketplace/cc-listing-page'),
  'CCListingPage'
)

export const EmbeddedPage = asyncComponent(
  () => import(/* webpackChunkName: "EmbeddedPage" */ './components/embedded-page'),
  'EmbeddedPage'
)

export const HomePage = asyncComponent(() => import(/* webpackChunkName: "HomePage" */ './pages/home'), 'Home')

export const LoanDetailPage = asyncComponent(
  () => import(/* webpackChunkName: "LoanDetailPage" */ './components/marketplace/loan-detail-page'),
  'LoanDetailPage'
)

export const LoanTypeListingPage = asyncComponent(
  () => import(/* webpackChunkName: "LoanTypeListingPage" */ './components/marketplace/loan-type-listing-page'),
  'LoanTypeListingPage'
)

export const LoanTypesPage = asyncComponent(
  () => import(/* webpackChunkName: "LoanTypesPage" */ './components/marketplace/loan-types-page'),
  'LoanTypesPage'
)

export const OptInPage = asyncComponent(() => import(/* webpackChunkName: "OptInPage" */ './pages/spq'), 'Spq')

export const BusinessProfilePage = asyncComponent(
  () => import(/* webpackChunkName: "BusinessProfilePage" */ './pages/business-profile'),
  'BusinessProfile'
)

export const NotFoundPage = asyncComponent(
  () => import(/* webpackChunkName: "NotFoundPage" */ './components/not-found-page'),
  'NotFoundPage'
)

export const BusinessMatchSearchPage = asyncComponent(
  () => import(/* webpackChunkName: "BusinessMatchSearchPage" */ './pages/business-match/search-page'),
  'BusinessMatchSearchPage'
)

export const BusinessMatchResultsPage = asyncComponent(
  () => import(/* webpackChunkName: "BusinessMatchResultsPage" */ './pages/business-match/results-page'),
  'BusinessMatchResultsPage'
)

export const BusinessMatchNoMatchPage = asyncComponent(
  () => import(/* webpackChunkName: "BusinessMatchNoMatchPage" */ './pages/business-match/no-match-page'),
  'BusinessMatchNoMatchPage'
)

export const SettingsPage = asyncComponent(
  () => import(/* webpackChunkName: "SettingsPage" */ './pages/settings'),
  'SettingsPage'
)

export const SettingsAccountDetailsPage = asyncComponent(
  () => import(/* webpackChunkName: "SettingsAccountDetailsPage" */ './pages/settings/account-details'),
  'AccountDetailsWrapper'
)

export const SettingsAuthorizationsPage = asyncComponent(
  () => import(/* webpackChunkName: "SettingsAuthorizationsPage" */ './pages/settings/authorizations'),
  'Authorizations'
)

export const SettingsBusinessPage = asyncComponent(
  () => import(/* webpackChunkName: "SettingsBusinessPage" */ './pages/settings/business'),
  'SettingsBusinessPage'
)

export const SettingsBillingInfoPage = asyncComponent(
  () => import(/* webpackChunkName: "SettingsBillingInfoPage" */ './pages/settings/billing-info'),
  'SettingsBillingInfoPage'
)

export const SettingsUpdateBillingPage = asyncComponent(
  () => import(/* webpackChunkName: "SettingsUpdateBillingPage" */ './pages/settings/update-billing'),
  'SettingsUpdateBillingPage'
)

export const SecurityPage = asyncComponent(
  () => import(/* webpackChunkName: "SecurityPage" */ './pages/settings/security'),
  'SecurityPage'
)

export const SettingsPlanDetailsPage = asyncComponent(
  () => import(/* webpackChunkName: "SettingsPlanDetailsPage" */ './pages/settings/plan-details'),
  'PlanDetailsPage'
)

export const SettingsCancelPlanPage = asyncComponent(
  () => import(/* webpackChunkName: "SettingsCancelPlanPage" */ './pages/settings/cancel/page'),
  'CancelPlan'
)

export const TradelinePage = asyncComponent(
  () => import(/* webpackChunkName: "TradelinePage" */ './components/tradeline-page'),
  'TradelinePage'
)

export const ContactPage = asyncComponent(
  () => import(/* webpackChunkName: "ContactPage" */ './components/contact-page'),
  'ContactPage'
)

export const SBALoanCalculator = asyncComponent(
  () => import(/* webpackChunkName: "SBALoanCalculator" */ './components/sba-loan-calculator/page'),
  'SBALoanCalculator'
)

export const BestPhoneNumber = asyncComponent(
  () => import(/* webpackChunkName: "BestPhoneNumber" */ './pages/spq/best-contact-phone'),
  'BestPhoneNumber'
)

export const PPPFormPage = asyncComponent(
  () => import(/* webpackChunkName: "PPPFormPage" */ './pages/ppp-form/index'),
  'PPPFormPage'
)

export const LoggedOutPPPFormPage = asyncComponent(
  () => import(/* */ './pages/ppp-form/logged-out-form/index'),
  'LoggedOutPPPFormPage'
)

export const OptInMOFPage = asyncComponent(() => import(/* */ './components/marketplace/opt-in-mof'), 'OptInMOF')

export const FundingApplication = asyncComponent(() => import('./pages/funding-application'), 'FundingApplication')
